import { RootState } from 'store/index';
import createResourceListSelectors from 'store/ResourceListSelectors';
import { PointOfInterestState, ResourceListSelectors } from 'typings/state';

const selectors: ResourceListSelectors = createResourceListSelectors(
    (state: RootState): PointOfInterestState => state.poi,
);

export default selectors;
